import "@opendaw/lib-std";
import { ObjectField, NoPointers, Int32Field, } from "@opendaw/lib-box";
export class Signature extends ObjectField {
    static create(construct) {
        return new Signature(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get nominator() {
        return this.getField(1);
    }
    get denominator() {
        return this.getField(2);
    }
    initializeFields() {
        return {
            1: Int32Field.create({
                parent: this,
                fieldKey: 1,
                fieldName: "nominator",
                pointerRules: NoPointers,
            }, 4),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "denominator",
                pointerRules: NoPointers,
            }, 4),
        };
    }
}
